// src/infrastructure/EmissionRepository.js
import apiClient from './apiClient';

export class EmissionRepository {
    constructor() {
        this.apiClient = apiClient;
    }

    async fetchVehicleEmissionTrail(vehicleId, month) {
        try {
            const response = await this.apiClient.get('api/CarbonEmission/monthly-emission-points', {
                params: { vehicleId, month }
            });
            return response.data;
        } catch (error) {
            console.error('API error:', error);
            throw new Error('從API獲取數據時發生錯誤');
        }
    }

    async fetchEmissionStats() {
        try {
            const response = await this.apiClient.get('/CarbonEmission/stats');
            return response.data;
        } catch (error) {
            console.error('API error:', error);
            throw new Error('從API獲取碳排放統計數據時發生錯誤');
        }
    }

    async fetchEmissionRankings() {
        try {
            const response = await this.apiClient.get('/CarbonEmission/rankings');
            return response.data;
        } catch (error) {
            console.error('API error:', error);
            throw new Error('從API獲取碳排放排名時發生錯誤');
        }
    }
}